import { render } from "./InfoMessage.vue?vue&type=template&id=a84c6bc4"
import script from "./InfoMessage.vue?vue&type=script&lang=js"
export * from "./InfoMessage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__